import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { AiFillInstagram, AiFillMail } from "react-icons/ai"
import { FaLinkedinIn } from "react-icons/fa"
import localization from "utils/localization"

const Contact = () => (
    <Container fluid className="home-about-section" id="about">
        <Row>
            <Col md={12} className="home-about-social">
                <h1>{ localization('contact-title') }</h1>
                <p>
                    { localization('contact-desc')} <span className="purple">{ localization('social-networks', true) }</span>
                </p>
                <ul className="home-about-social-links">
                    <li className="social-icons">
                        <a href="mailto:rodrigo4635@gmail.com" target="_blank" rel="noreferrer" className="icon-colour  home-social-icons">
                            <AiFillMail />
                        </a>
                    </li>
                    <li className="social-icons">
                        <a href="https://www.linkedin.com/in/rodrigopasini/" target="_blank" rel="noreferrer" className="icon-colour  home-social-icons">
                            <FaLinkedinIn />
                        </a>
                    </li>
                    <li className="social-icons">
                        <a href="https://www.instagram.com/rodrigo.pasin1/" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" >
                            <AiFillInstagram />
                        </a>
                    </li>
                </ul>
            </Col>
        </Row>
    </Container>
)

export default Contact